module.exports = __webpack_public_path__ + "img/introduction_bg4.15c966d9.png";